<template>
    <div id="about" class="w-100 tc">
        <!-- <h1 class="">About</h1> -->
        <div class="w-100 cover"></div>

        <div class="w-80-ns w-90 mt5-ns mt3 tc center">
            <h2 class="pa3 f2 tracked">Who We Are</h2>
            <hr class="w-30-ns w-75">
            <div class="mt3 center f4-ns f5 tj lh-copy-ns tj">United Builders Group is a commercial construction company based in New York City. No surprises or disappointments. If you can dream it, we can build it. We maintain control throughout the design and construction process to ensure that your project is built to the highest quality standards. We are able to manage all stages of your project. From the pre-design phase of a project through construction and delivery. We form alliances with property owners, architects, engineers, and specialized trades people. </div>
            <!-- <router-link class="pa3 ph6 f3 br3 button shadow-1 mt4" to="/contact" tag="button">Contact Us</router-link> -->
        </div>
        <div class="mt5 story h5"></div>
        <div class="w-80-ns w-90 mt5-ns mt3 tc center">
            <h2 class="pa3 f2 tracked mt5-ns mt3">Our Story</h2>
            <hr class="w-20-ns w-40">
            <div class="mt3 center f4-ns f5 tj lh-copy-ns tj">
                <div>United Builders Group was started by Travis Wood. He started a business when all signs indicated that it was not the best time to do so. But that is what it takes. The idea of United Builders Group went from a computer and a printer in a home office to what has turned into a multimillion dollar company that can tackle any task. United Builders Group was and is built upon the backbone of integrity. Our budgets are real and our schedules are real. Transparency, efficiency, and truth are what we believe in.</div>
                <br/><div>We have completed over 1 million square feet of office space renovations and our residential projects have been featured in many professionally recognized publications.</div>
                <br/><div>Commercially focused; we work with Developers in repositioning office buildings. Our local knowledge of costs along with our supplier & vendor relationships have proven to be valuable assets in ensuring competitive pricing for developers and investors alike.</div>
                <br/><div>Residentially focused; we approach each project with a sophisticated level of detail. No step is less important than the next. Our detailed approach in planning with the buildings management board, architect, engineers, and special inspectors ensures a quality built project that is delivered on time and on budget. </div>
                </div>
           <div class="container">
                <div class="ph1 h5 pic center mt3"  v-for="(image, i) in stock" :key="i">
                    <img class="w-100 h-100" v-lazy="image.link"/>
                </div>
                <span class="stretch"></span>
            </div> 
            
            <!-- <router-link class="pa3 ph6 f3 br3 button shadow-1 mt4" to="/portfolio" tag="button">Our Projects</router-link> -->
        </div>
            <div class=""></div>
            <div class="w-80-ns w-90 mt5-ns mt3 tc center">
            <h2 class="pa3 f2 tracked mt5-ns mt3">Leaders</h2>
            <hr class="w-10-ns w-34">
            <div class="team mt5-ns">
                <div class="container cf">
                    <div class="ph1 w-40-ns tc center" v-for="i in team.length " :key="i" :class="i <= team.length-1 ? 'fl' : 'fr'">
                        <div>
                            <!-- <img class="w-100 h-100 pt3" :src="team[i-1].link" /> -->
                            <div class="ttu b1 f2-ns f3 tracked">{{ team[i-1].name }}</div>
                            <div class="pb2 mt2 f3-ns f4 lh-copy">{{ team[i-1].job }}</div>
                            <div class="pb2 mt2 f4-ns f5 tj lh-copy-ns">{{ team[i-1].desc }}</div>
                            <span class="stretch"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <h2 class="pa3 f2 tracked mt5-ns mt3">Clients</h2>
        <hr class="w-10-ns w-34">
        <Carousel :pics="clientList" :homeProp="false" :perPageCount="3" :fast="2500" :fillBool="true"/>
    </div>
</template>

<script>
import Carousel from '@/components/Carousel'
export default {
    name: 'About',
    data: function() {
        return {
            team: [
                {name: "Travis Wood", job: "Founder & Managing Partner", link: "https://image.shutterstock.com/mosaic_250/1849259/575234476/stock-photo-good-looking-man-in-glasses-portrait-575234476.jpg",
                    desc: "Travis started United Builders Group in 2010 and has grown the company every year since inception.  Travis comes from humble beginnings starting in the Midwest.  Many years ago he started a job stripping bark off logs at a timber mill for twelve cents a foot – he ended up running that same mill.  He sees the dilemma that exists in inefficient construction projects.  He focuses on client driven requests and puts forth practical, cost effective solutions that help see our client projects to the finish line. Travis started United Builders Group when everyone told him not to.  The recession was in full swing and he stuck to his guns.  He focused on his clients.  He did right by his clients.  Over the past decade he created a company that not only performs but stands by its word.  The construction world has been shaped by people who do just the opposite.  Travis is not one of those people.  He will rip off the Band-Aid and tell you reality and in the end you will get what you want and know exactly what it costs to get there and how long it will take."
                },
                {name: "Paul Berger", job: "Managing Partner", link: "https://image.shutterstock.com/mosaic_250/2936380/788313199/stock-photo-smiling-bearded-young-male-model-rejoices-coming-weekends-dressed-casually-isolated-over-white-788313199.jpg",
                    desc: "Paul came to United Builders Group in 2014 after almost two decades in finance.  Paul’s first real job out of college started in the pits of the Chicago Mercantile Exchange – (although his first job at 14 was as a dishwasher making $2.35 an hour).  He climbed the financial ladder and ended his career as a high frequency commodity ETF arbitrageur.  He brought this financial and detail oriented business mind to the world of construction.  Construction is years behind technology and in dire need of more transparency, efficiency and outright integrity. Paul is originally from San Diego, CA.  He got his Bachelor of Science in Mechanical Engineering from The University of Pennsylvania.  He then went to Oxford University for a graduate degree in politics, philosophy, and economics.  He was also a competitive rower in college, having rowed in the varsity and blue boat at both UPenn and Oxford.  He went on to trial for the U.S. Olympic rowing team in the late 90’s.  He even shook off the rust and tasted first place victory in 2016 in the master’s 8 at the Head of the Charles in Boston. Paul and Travis are business partners at United Builders Group, LLC."
                }
            ],
            stock: [
                {link: "https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1353&q=80"},
                {link: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"},
                {link: "https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"},
            ],
            clientList: [
                "https://blog.hubspot.com/hubfs/image8-2.jpg",
                "https://static.wixstatic.com/media/387d54_9f545acf8db34afdafbc470488cc6054~mv2.jpg/v1/fill/w_225,h_44,al_c,q_80,usm_0.66_1.00_0.01/Logo-Bernstein-Blue_JPG.webp",
                "https://i1.wp.com/rewomen.org/wp-content/uploads/2016/05/2011_cbre_logo_green-2.jpg?ssl=1",
                "http://nebula.wsimg.com/ac0bbd6576cd3b3f57454e9d3d767419?AccessKeyId=B0575FF504F3502A6410&disposition=0&alloworigin=1",
                "https://2h7qju2c3qvcc3s86ekn8n0-wpengine.netdna-ssl.com/wp-content/uploads/2013/11/nwc-icon-220x200.jpg",
                "https://static1.squarespace.com/static/5b846bb7af20960aea643be2/t/5b881c1a0ebbe865f5e8dd19/1535646746156/GAlogo600px%4072dpi_blk.png",
                "https://pbs.twimg.com/profile_images/2813068139/a891114e98df216008b1c4035d8165c9_400x400.jpeg",
                "https://therealdeal.com/new-research/wp-content/uploads/2019/03/TribecaAssociates-194x187.jpg",
                "https://media.licdn.com/dms/image/C4E0BAQFBKDo3G0Xl9A/company-logo_200_200/0?e=2159024400&v=beta&t=Nkt-9US4WLb3mFRFr_TnAMjyaaxoHBrVcJn3H43GUZI",
                "https://s3-media2.fl.yelpcdn.com/bphoto/FMur8q1x5isHXImA67Yi8g/ls.jpg",
                "http://nebula.wsimg.com/5b1e00781f15758f44bf63bf95406d9c?AccessKeyId=B0575FF504F3502A6410&disposition=0&alloworigin=1",
                "http://nebula.wsimg.com/1a04d6143336f7960c6b84d39aa6366f?AccessKeyId=B0575FF504F3502A6410&disposition=0&alloworigin=1"
            ]
        }
    },
    components: {Carousel}
}
</script>

<style scoped>
.container {
    margin-top:50px;
    margin-left: auto; 
    margin-right: auto;
}
.container .pic {
    vertical-align: top;
}

@media screen and (max-width: 600px){
    .container .pic {
        zoom: 1;
        width: 100%;
    }
}
@media screen and (min-width: 601px){
    .container .pic {
        display: inline-block;
        *display: inline;
        zoom: 1;
        width: 33%;
    }
}

.stretch {
    width: 100%;
    display: inline-block;
    font-size: 0;
    line-height: 0
}
.image-container {
    max-width: 650px;
    max-height: 525px;
}
.story {
    height: 500px;
    background-image: url("https://images.unsplash.com/reserve/LJIZlzHgQ7WPSh5KVTCB_Typewriter.jpg?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=641&q=80");
    background-position: 50%, 20%;
}
.leaders {
    height: 750px;
    background-image: url('https://images.unsplash.com/photo-1500228630616-d6905f33ad1a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1372&q=80');
    background-size: cover;
}
.cover {
    background: url('https://images.unsplash.com/photo-1470075801209-17f9ec0cada6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80');
    height: 70vh;
    background-position: 20% 20%;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;    
    text-align: center;
    margin: auto;
}
</style>
